function scrollToServiceOnline() {
    const headerHeight = $('header').outerHeight();
    const targetOffset = $('#WebDMSServiceWidget').offset().top;
    $('html, body').animate(
        {
            scrollTop: targetOffset - headerHeight,
        },
        1000
    );
}

$(document).ready(function () {
    $('.scrollToServiceOnlineIframe').on('click', function () {
        event.preventDefault();
        event.stopPropagation();
        scrollToServiceOnline();
    });
});